<style lang="scss" scoped>
.home-hero {
    position: relative;
}

.background-image {
    position: relative;
    overflow: hidden;
    height: 75vh;
    height: calc(var(--vh, 1vh) * 75);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    &:after {
        content: "";
        background-color: #172340;
        opacity: 0.75;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
    }

    .video-wrapper {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        transition: opacity 0.5s;

        &.visible {
            opacity: 1;
        }

        > div {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);

            ::v-deep iframe {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }
    }
}

.content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    h1 {
        font-size: 2.5rem;
        line-height: 1.2;

        ::v-deep .outline {
            color: #fff;
            -webkit-text-fill-color: transparent; /* Will override color (regardless of order) */
            -webkit-text-stroke-width: 2px;
            -webkit-text-stroke-color: #fff;
        }

        @media (min-width: 768px) {
            font-size: 4rem;
            line-height: 1;
        }

        @media (min-width: 1440px) {
            font-size: 6rem;
        }
    }

    p {
        font-size: 1.25rem;
        line-height: 1.2;
        text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.32);

        @media (min-width: 768px) {
            font-size: 1.5rem;
        }

        @media (min-width: 1440px) {
            font-size: 2rem;
        }
    }
}
</style>

<template>
    <div class="home-hero">
        <div class="background-image" ref="bg" :style="`background-image: url('${image}')`">
            <template v-if="video_id != null && video_id != ''">
                <div class="video-wrapper" ref="videowrapper" v-if="heroLoaded">
                    <vimeo-player :video-id="video_id" ref="videoplayer" @ready="videoPlayerReady" :player-width="videoClientWidth" :player-height="videoClientHeight" :autoplay="true" :loop="true" :options="vimeoOptions"></vimeo-player>
                </div>
            </template>
        </div>

        <div class="content d-flex justify-content-center align-content-start flex-column">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-xl-11 offset-xl-1 text-center text-md-left">
                        <h1 class="mb-40 text-white" v-html="title"></h1>
                    </div>

                    <div class="col-12 col-md-10 col-lg-8 offset-xl-1 text-center text-md-left">
                        <div class="row">
                            <div class="col-12 col-xl-10">
                                <p class="mb-40 text-white font-weight-light" v-html="text"></p>
                                <a class="btn btn-accent align-self-start" :href="href">{{ btn }} <span class="arrow-right" v-html="svg('arrow-right')" /></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "pageParts.home-hero-row",

    props: {
        title: {
            type: String,
            required: true,
            default: ''
        },
        text: {
            type: String,
            required: true,
            default: ''
        },
        image: {
            type: String,
            required: true,
            default: ''
        },
        video_id: {
            type: String,
            required: false,
            default: ''
        },
        btn: {
            type: String,
            required: true,
            default: '',
        },
        href: {
            type: String,
            required: true,
            default: '',
        },
    },

    data: (vm) => ({
        oldWidth: document.documentElement.clientWidth,
        loaded: false,
        videoReady: false,
    }),

    mounted() {
        var self = this;
        this.loaded = true;

        if (this.video_id != null && this.video_id != '') {
            window.addEventListener('resize', _.debounce(() => { // only on width change because URL bar resizing on mobile      
                var newWidth = document.documentElement.clientWidth;
                if (newWidth != self.oldWidth) {
                    self.$refs.videoplayer.update(self.video_id);
                }
                self.oldWidth = newWidth;
            }), 300, { leading: true, trailing: true });

            window.addEventListener('orientationchange', () => {
                self.$refs.videoplayer.update(self.video_id);
            })
        }
    },

    methods: {
        videoPlayerReady() {
            var self = this;

            this.videoReady = true;

            setTimeout(function () {
                self.$refs.videowrapper.classList.add("visible");
            }, 1000);
        },
    },

    computed: {
        heroLoaded() {
            return this.loaded;
        },

        vimeoOptions() {
            return {
                'controls': false,
                'muted': true,
                'autopause': false
            }
        },

        videoClientHeight() {
            if (this.$refs.bg.clientWidth / this.$refs.bg.clientHeight > (16 / 9)) {
                return this.$refs.bg.clientWidth / 16 * 9;
            } else {
                return this.$refs.bg.clientHeight;
            }
        },

        videoClientWidth() {
            if (this.$refs.bg.clientWidth / this.$refs.bg.clientHeight > (16 / 9)) {
                return this.$refs.bg.clientWidth;
            } else {
                return this.$refs.bg.clientHeight / 9 * 16;
            }
        },
    }
}
</script>